const Home = [
  {
    path: '',
    redirect: 'repositories'
  },
  {
    path: 'repositories',
    component: () => import('../views/children/repositories'),
    meta: {
      title: '库列表',
      needLogin: true // 是否需要登录才能访问
    }
  },
  {
    path: 'contract',
    component: () => import('../views/children/contract'),
    meta: {
      title: '合同管理',
      needLogin: true // 是否需要登录才能访问
    }
  },
  {
    path: 'contractList',
    component: () => import('../views/children/contractList'),
    meta: {
      title: '合同管理',
      needLogin: true // 是否需要登录才能访问
    }
  },
  {
    path: 'contractDetail',
    component: () => import('../views/children/contractDetail'),
    meta: {
      title: '合同管理',
      needLogin: true // 是否需要登录才能访问
    }
  },
  {
    path: 'contractStatistics',
    component: () => import('../views/children/contractStatistics'),
    meta: {
      title: '合同管理',
      needLogin: true // 是否需要登录才能访问
    }
  },
  {
    path: 'repositoriesShare',
    component: () => import('../views/children/repositoriesShare'),
    meta: {
      title: '分享给我的',
      needLogin: true // 是否需要登录才能访问
    }
  },
  {
    path: 'list',
    component: () => import('../views/children/list'),
    meta: {
      title: '文件夹列表',
      needLogin: true // 是否需要登录才能访问
    }
  },
  {
    path: 'detail',
    component: () => import('../views/children/detail'),
    meta: {
      title: '文件详情',
      needLogin: true // 是否需要登录才能访问
    }
  },
  {
    path: 'repositoriesClose',
    component: () => import('../views/children/repositoriesClose'),
    meta: {
      title: '回收站',
      needLogin: true // 是否需要登录才能访问
    }
  },
  {
    path: 'repositoriesTeam',
    component: () => import('../views/children/repositoriesTeam'),
    meta: {
      title: '成员管理',
      needLogin: true // 是否需要登录才能访问
    }
  },
  {
    path: 'repositoriesSearch/:keyWord',
    component: () => import('../views/children/repositoriesSearch'),
    meta: {
      title: '搜索',
      needLogin: true // 是否需要登录才能访问
    }
  },

]

export default Home
